import React, { useState } from "react"
import { Box, TableContainer } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { Company } from "src/openapi"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import "./company_table.scss"

interface Props {
  data: Company[]
}
export const CompanyTable = ({ data }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "company" })

  const navigate = useNavigate()

  const [hoverIndex, setHoverIndex] = useState<number>()

  return (
    <TableContainer
      style={{
        width: "100%",
        height: "calc(100vh - 180px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Table className="company_table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "5%" }}>{t("employer_id")}</TableCell>
            <TableCell sx={{ width: "15%" }}>{t("company_name")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("ceo_name")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("post_code")}</TableCell>
            <TableCell sx={{ width: "20%" }}>{t("address")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("phone_number")}</TableCell>
            <TableCell sx={{ width: "16%" }}>{t("mail_address")}</TableCell>
            <TableCell sx={{ width: "10%" }}>{t("product_permission")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length == 0 ? (
            <TableRow>
              <TableCell colSpan={10} sx={{ textAlign: "center" }}>
                {t("no_data")}
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, index) => {
              return (
                <TableRow
                  key={`${row.id}`}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(undefined)}
                  className={`${index === hoverIndex ? "td-hover" : ""}`}
                  onClick={() => {
                    navigate(`/company/${row.id}/employee`)
                  }}
                >
                  <TableCell>{row.employerId}</TableCell>
                  <TableCell>{row.companyName}</TableCell>
                  <TableCell>{row.ceo}</TableCell>
                  <TableCell>{row.postCode}</TableCell>
                  <TableCell>{`${row.province} ${row.city} ${row.address} ${row.buildingNo}`}</TableCell>
                  <TableCell>{row.phoneNumber}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>
                    <Box>
                      {row.productPermissions.map((p) => (
                        <Box key={p.id} className="product-permission-item">
                          {p.productName}
                        </Box>
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
